import React from 'react'
import "./Timeline.css";

function TimeLine() {
    return (

<div>
<div class="wrap">
    <div class="center-line">
      <a href="https" class="scroll-icon"><i class="fas fa-caret-up"></i></a>
    </div>
    <div class="row row-1">
      <section class="box box-down blue" style={{background:"transparent"}}>
        <i class="icon fas fa-home"></i>
        <div class="details">
          <span class="title">Registration Starts</span>
          <span>18th Dec 2022</span>
        </div>
        <p className="timeline_text" style={{fontSize: "14px"}}>
       {<b>Instructions for teams:</b>} {<br/>}
1. This is the form for {<b>Reserving the spots</b>} only. Form for Abstract submission of teams will be sent only after reservation of spot through mail.{<br/>}
2. Teams are informed to fill in the form carefully. {<br/>}

        </p>
       
      </section>
    </div>
    <div class="row row-2">
      <section class="box box-down orange" style={{background:"transparent"}}>
        <i class="icon fas fa-star"></i>
        <div class="details">
          <span class="title">Registration Ends</span>
          <span>13th Jan 2023</span>
        </div>
        <p  className="timeline_text" style={{fontSize: "14px"}}>
        {<b>Instructions for teams:</b>} {<br/>}
        1. For teams who have qualified the abstract round, their registration fee will be {<b>Zero</b>} and  {<b>Rs. 300/- per person (Fooding & Lodging charges)</b>}{<br/>}
        2.For teams from MMMUT, the registration fee will be{<b> Rs. 300/- per team</b>}.
        3.{<b>Please Note</b>} : Registration fees have to be paid ONLY after qualifying the abstract round. Details of the same will be sent on the date of result declaration.
        </p>
      
      </section>
    </div>
    <div class="row row-1">
      <section class="box box-down blue" style={{background:"transparent"}}>
        <i class="icon fas fa-home"></i>
        <div class="details">
          <span class="title">Accomodation for Teams</span>
          <span>03 Feb 2023</span>
        </div>
         <p className="timeline_text" style={{fontSize: "14px"}}>Accomodation will be started for shortlisted teams after 5:00PM</p>
        
      </section>
    </div>
   
    <div class="row row-2">
      <section class="box box-down orange" style={{background:"transparent"}}>
        <i class="icon fas fa-rocket"></i>
        <div class="details">
          <span class="title">Opening Ceremony</span>
          <span>04th Feb 2023</span>
        </div>
        <p className="timeline_text" style={{fontSize: "14px"}}>Hackathon opening ceremony will start 10:00 AM onwards.</p>
        
      </section>
    </div>
    <div class="row row-1">
      <section class="box box-down blue" style={{background:"transparent"}}>
        <i class="icon fas fa-globe"></i>
        <div class="details">
          <span class="title">Hackathon Phase-1 Starts</span>
          <span>04th Feb 2023</span>
        </div>
        <p className="timeline_text" style={{fontSize: "14px"}}>Hackathon phasae-1 i.e front-end will start 11:30 AM onwards.</p>
      </section>
    </div>
    <div class="row row-2">
      <section class="box box-down orange" style={{background:"transparent"}}>
        <i class="icon fas fa-paper-plane"></i>
        <div class="details">
          <span class="title">Phase-1 Evaluation</span>
          <span>04th Feb 2023</span>
        </div>
        <p className="timeline_text" style={{fontSize: "14px"}}>Evaluation based on UI design .</p>
        
      </section>
    </div>
    <div class="row row-1">
      <section class="box box-down blue" style={{background:"transparent"}}>
        <i class="icon fas fa-paper-plane"></i>
        <div class="details">
          <span class="title">Hackathon Phase-2 Starts</span>
          <span>04th Feb 2023</span>
        </div>
        <p className="timeline_text" style={{fontSize: "14px"}}>Hackathon back-end coding period will start from 8:30 PM onwards.</p>
        
      </section>
    </div>
    <div class="row row-2">
      <section class="box box-down orange" style={{background:"transparent"}}>
        <i class="icon fas fa-paper-plane"></i>
        <div class="details">
          <span class="title">Phase-2 Evaluation</span>
          <span>05th Feb 2023</span>
        </div>
        <p className="timeline_text" style={{fontSize: "14px"}}>Evaluation based on backend functionality and api working .</p>
        
      </section>
    </div>
    <div class="row row-1">
      <section class="box box-down blue" style={{background:"transparent"}}>
        <i class="icon fas fa-globe"></i>
        <div class="details">
          <span class="title">Hackathon Ends</span>
          <span>05th Feb 2023</span>
        </div>
        <p className="timeline_text" style={{fontSize: "14px"}}>Hackathon coding period will end on 11:30 AM.</p>
        
      </section>
    </div>
    <div class="row row-2">
      <section class="box box-down red" style={{background:"transparent"}}>
        <i class="icon fas fa-paper-plane"></i>
        <div class="details">
          <span class="title">Closing Ceremony</span>
          <span>05th Feb 2023</span>
        </div>
        <p className="timeline_text" style={{fontSize: "14px"}}>Hackathon prize distribution ceremony and closing cerenmony will start after 2 hours when the coding period ended.</p>
        
      </section>
    </div>
  </div>
         </div>
    );
  }
  
  export default TimeLine;